/* eslint-disable */
import React, { useContext, useEffect, useCallback, useState, useRef } from 'react'
import { UserContext } from 'account'
import { LayoutContext, app } from 'common/ducks/index'
import { PieChart, Pie, Cell, Label, ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, Bar, BarChart } from 'recharts';
import styled from 'styled-components'
import useApi from 'common/hooks/useApi'
import useAppTitle from 'common/hooks/useAppTitle'
import moment from 'moment'
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField, Grid, Chip} from '@mui/material'
import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-alpine.css";
import { ModuleRegistry, AllCommunityModule, themeAlpine, provideGlobalGridOptions } from 'ag-grid-community'
import { pdf, Document, Page, View, Text, StyleSheet, Font } from "@react-pdf/renderer";


ModuleRegistry.registerModules([ AllCommunityModule ]);
provideGlobalGridOptions({
    theme: "legacy",
});


const styles = StyleSheet.create({
  table: {
    width: '100%',
    marginTop: '30px',
  },
  tableCommon: {
    width: "100%",
    border: "1px solid #eeeeee",
    borderRadius: "4px",
    margin: "5px",
    backgroundColor: "white"
  },
  titleShort: {
    flexDirection: 'row',
    fontSize: "8px",
    color: "white",
    backgroundColor: "#0B545E",
    height: '20px',
    width: "80%",
  },
  titleShort2: {
    flexDirection: 'row',
    fontSize: "8px",
    color: "white",
    backgroundColor: "#0B545E",
    height: '20px',
    width: "70%",
  },
  titleShortKpi: {
    flexDirection: 'row',
    fontSize: "8px",
    color: "white",
    backgroundColor: "#0B545E",
    height: '20px',
    width: "350px",
  },
  titleLong: {
    flexDirection: 'row',
    fontSize: "8px",
    color: "white",
    backgroundColor: "#0B545E",
    height: '20px',
    width: "120%",
  },
  titleLongKpi: {
    flexDirection: 'row',
    fontSize: "8px",
    color: "white",
    backgroundColor: "#0B545E",
    height: '20px',
    width: "700px",
  },
  titleKpiWT: {
    flexDirection: 'row',
    fontSize: "8px",
    color: "white",
    backgroundColor: "#0B545E",
    height: '20px',
    width: "550px",
  },
  titleLRS: {
    flexDirection: 'row',
    fontSize: "8px",
    color: "white",
    backgroundColor: "#0B545E",
    height: '20px',
    width: "120%",
  },
  titleLRS2: {
    flexDirection: 'row',
    fontSize: "8px",
    color: "white",
    backgroundColor: "#0B545E",
    height: '20px',
    width: "140%",
  },
  titleRT: {
    flexDirection: 'row',
    fontSize: "8px",
    color: "white",
    backgroundColor: "#0B545E",
    height: '20px',
    width: "100%",
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
  },
  cellDataName: {
    fontSize: "10px",
    marginTop: "5px",
    paddingLeft: "1%",
    width: "120%",
    height: '20px',
    border: "1px solid #eeeeee",
  },
  cellDataName2: {
    fontSize: "10px",
    marginTop: "5px",
    paddingLeft: "1%",
    width: "310px",
    height: '20px',
    border: "1px solid #eeeeee",
  },
  cellDataKpiProgramInfo: {
    fontSize: "10px",
    marginTop: "5px",
    paddingLeft: "1%",
    width: "310px",
    height: '20px',
    border: "1px solid #eeeeee",
  },
  cellDataShort: {
    fontSize: "10px",
    marginTop: "5px",
    paddingLeft: "3%",
    width: "80%",
    height: '20px',
    border: "1px solid #eeeeee",
  },
  cellDataShort2: {
    fontSize: "10px",
    marginTop: "5px",
    paddingLeft: "3%",
    width: "70%",
    height: '20px',
    border: "1px solid #eeeeee",
  },
  cellDataRT: {
    fontSize: "10px",
    marginTop: "5px",
    paddingLeft: "3%",
    width: "100%",
    height: '20px',
    border: "1px solid #eeeeee",
  },
  cellDataKpi: {
    fontSize: "10px",
    marginTop: "5px",
    paddingLeft: "4%",
    width: "160px",
    height: '20px',
    border: "1px solid #eeeeee",
  },
  cellDataKpiWT: {
    fontSize: "10px",
    marginTop: "5px",
    paddingLeft: "5%",
    width: "260px",
    height: '20px',
    border: "1px solid #eeeeee",
  },
  cellDataLong: {
    fontSize: "10px",
    marginTop: "5px",
    paddingLeft: "5%",
    width: "120%",
    height: '20px',
    border: "1px solid #eeeeee",
  },
  cellDataLRS: {
    fontSize: "10px",
    marginTop: "5px",
    paddingLeft: "0px",
    width: "140%",
    height: '20px',
    border: "1px solid #eeeeee",
  },
  border: {
    border: "1px solid #eeeeee",
    margin: "4px",
    borderRadius: "4px",
    paddingLeft: "5px"
  },
  tableExercises: {
    width: "100%",
    border: "1px solid #eeeeee",
    borderRadius: "4px",
    margin: "5px",
    marginLeft: '0px',
    backgroundColor: "white",
    display: 'flex',
    flexDirection: 'row',
  },
  kpiTitle: {
    marginBottom: '20px',
    marginLeft: '20px'
  }
});


function TeamReportPage() {
  useAppTitle('Team Report')
  const user = useContext(UserContext)
  const { setAppLoading } = useContext(LayoutContext)
  const [org, setOrg] = useState('')
  const [orgList, setOrgList] = useState([])
  const [cardData, setCardData] = useState({memberDataList: []})
  const [days, setDays] = useState(7)
  const [members, setMembers] = useState(0)
  const gridRef = useRef()
  const gridRefKpi = useRef()

  const defaultColDef = {
      resizable: true,
      sortable: true,
      filter: true,
      wrapText: true,
      autoHeight: true,
    }

  const [colDefs,] = useState([
    {
      headerName: 'Name',
      field: 'name',
    },
    {
      headerName: 'Momentum Score',
      field: 'momentum_score',
      cellClass: 'ag-right-aligned-cell'
    },
    {
      headerName: 'Training Adherence (%)',
      field: 'compliance_rate',
      cellClass: 'ag-right-aligned-cell'
    },
    {
      headerName: 'AVG Session Readiness',
      field: 'avg_readiness',
      cellClass: 'ag-right-aligned-cell'
    },
    {
      headerName: 'Recovery Trend (%)',
      field: 'recovery_trend',
      cellClass: 'ag-right-aligned-cell',
      cellDataType: 'text',
    },
    {
      headerName: 'Latest Session Readiness',
      field: 'readiness',
      cellClass: 'ag-right-aligned-cell'
    },
    {
      headerName: 'Last Recorded Session',
      field: 'recent_activity',
    },
    {
      headerName: 'AVG RPE',
      field: 'AVG_RPE',
      cellClass: 'ag-right-aligned-cell'
    },
    {
      headerName: 'Latest RPE',
      field: 'RPE',
      cellClass: 'ag-right-aligned-cell'
    },
    {
      headerName: 'Training Load',
      field: 'load_count',
      cellClass: 'ag-right-aligned-cell'
    },
  ]);

  const [kpiColDefs,] = useState([
    {
      headerName: 'Name',
      field: 'name',
    },
    {
      headerName: 'Exercise',
      field: 'exercise',
    },
    {
      headerName: 'Weight (lbs)',
      field: 'weight',
      cellClass: 'ag-right-aligned-cell'
    },
    {
      headerName: 'Sets',
      field: 'sets',
      cellClass: 'ag-right-aligned-cell'
    },
    {
      headerName: 'Reps',
      field: 'reps',
      cellClass: 'ag-right-aligned-cell'
    },
    {
      headerName: 'Distance',
      field: 'distance',
      cellClass: 'ag-right-aligned-cell'
    },
    {
      headerName: 'Work Time (seconds)',
      field: 'work_time',
      cellClass: 'ag-right-aligned-cell'
    },
    {
      headerName: 'Date',
      field: 'date',
    },
    {
      headerName: 'Program Info',
      field: 'program_info',
    },
  ]);

  const [{ loading: listLoading }, list ] = useApi({url: 'organization/'}, {manual: true})
  const [{ loading: orgLoading }, getOrg] = useApi(
    {
      method: 'POST',
      url: 'organization/org_data/',
    },
    { manual: true }
  )

  const fetchList = useCallback(
    async () => {
      const response = await list()
      setOrgList(response?.data)
      if (response?.data.length >= 1){
        setOrg(response?.data[0])
        let responseData = response?.data[0]
        getOrgData({id: responseData.id, name: responseData.name, days: 7 })
      }
    },[ list]
  )

  useEffect(() => {
    fetchList()
  }, [])

  useEffect(() => {
    setAppLoading(listLoading || orgLoading)
  }, [listLoading, orgLoading, setAppLoading])

  const hangleOrgChange = (event: SelectChangeEvent) => {
      setOrg(event.target.value);
      getOrgData(event.target.value)
  }

  const hangleDayChange = (event: SelectChangeEvent) => {
      setDays(event.target.value);
      if (org.id) {
        org.days = event.target.value
        getOrgData(org)
      }
  }

  async function getOrgData(data) {
    const body = {
      id: data.id,
      days: data.days
    }
    await getOrg({
      data: body,
    }).then((response) => {
      if(response?.status === 200){
        setCardData(response?.data)
        setMembers(`Members: ${response?.data?.memberCount}`)
      }
    })
  }

  const onBtnExport = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, [])
  const onBtnExport2 = useCallback(() => {
    gridRefKpi.current.api.exportDataAsCsv();
  }, [])



  const generatePDF = async () => {

    if(cardData?.memberDataList?.length > 0) {
      const cols = gridRef?.current?.api?.getAllGridColumns()
      const colsKpi = gridRefKpi?.current?.api?.getAllGridColumns()
      let gridRows = []
      gridRef?.current?.api?.forEachNodeAfterFilterAndSort((rowNode, index) => {
        gridRows.push(rowNode.data)
      })
      let gridRowsKpi = []
      gridRefKpi?.current?.api?.forEachNodeAfterFilterAndSort((rowNode, index) => {
        gridRowsKpi.push(rowNode.data)
      })

      const blob = await pdf(
        <Document>
          <Page style={styles.table} wrap size="A4" orientation="landscape">
            <Text style={styles.kpiTitle}>{cardData.orgName} Team Report</Text>
            <View key='Header Row' style={styles.row} wrap={true}>
              {cols.map((row, index) => {
                switch (row?.userProvidedColDef?.headerName) {
                  case "Name":
                    return <Text style={styles.titleLong}>Name</Text>
                    break
                  case "Momentum Score":
                    return <Text style={styles.titleShort}>Momentum Score</Text>
                    break
                  case "Training Adherence (%)":
                    return <Text style={styles.titleLong}>Training Adherence (%)</Text>
                    break
                  case "AVG Session Readiness":
                    return <Text style={styles.titleLong}>AVG Session Readiness</Text>
                    break
                  case "Recovery Trend (%)":
                    return <Text style={styles.titleRT}>Recovery Trend (%)</Text>
                    break
                  case "Latest Session Readiness":
                    return <Text style={styles.titleLRS}>Latest Session Readiness</Text>
                    break
                  case "Last Recorded Session":
                    return <Text style={styles.titleLRS2}>Last Recorded Session</Text>
                    break
                  case "AVG RPE":
                    return <Text style={styles.titleShort2}>AVG RPE</Text>
                    break
                  case "Latest RPE":
                    return <Text style={styles.titleShort2}>Latest RPE</Text>
                    break
                  case "Training Load":
                    return <Text style={styles.titleShort2}>Training Load</Text>
                    break
                }
              })}
            </View>
            {gridRows?.map((row, index) => (
              <View key={index + index} style={styles.tableExercises}>
                <View key={index} style={styles.row} wrap={true}>
                  {cols.map((col, index) => {
                    switch (col?.userProvidedColDef?.headerName) {
                      case "Name":
                        return <Text style={styles.cellDataName}>{row?.name}</Text>
                        break
                      case "Momentum Score":
                        return <Text style={styles.cellDataShort}>{row?.momentum_score}</Text>
                        break
                      case "Training Adherence (%)":
                        return <Text style={styles.cellDataLong}>{row?.compliance_rate}</Text>
                        break
                      case "AVG Session Readiness":
                        return <Text style={styles.cellDataLong}>{row?.avg_readiness}</Text>
                        break
                      case "Recovery Trend (%)":
                        return <Text style={styles.cellDataRT}>{row?.recovery_trend}</Text>
                        break
                      case "Latest Session Readiness":
                        return <Text style={styles.cellDataLong}>{row?.readiness}</Text>
                        break
                      case "Last Recorded Session":
                        return <Text style={styles.cellDataLRS}>{row?.recent_activity}</Text>
                        break
                      case "AVG RPE":
                        return <Text style={styles.cellDataShort2}>{row?.AVG_RPE}</Text>
                        break
                      case "Latest RPE":
                        return <Text style={styles.cellDataShort2}>{row?.RPE}</Text>
                        break
                      case "Training Load":
                        return <Text style={styles.cellDataShort2}>{row?.load_count}</Text>
                        break
                    }
                  })}
                </View>
              </View>
            ))}
          </Page>

          <Page style={styles.table} wrap size="A4" orientation="landscape">
            <Text style={styles.kpiTitle}>KPI Leaderboard</Text>
            <View key='Header Row' style={styles.row} wrap={true}>
              {colsKpi.map((row, index) => {
                switch (row?.userProvidedColDef?.headerName) {
                  case "Name":
                    return <Text style={styles.titleLongKpi}>Name</Text>
                    break
                  case "Exercise":
                    return <Text style={styles.titleLongKpi}>Exercise</Text>
                    break
                  case "Weight (lbs)":
                    return <Text style={styles.titleShortKpi}>Weight (lbs)</Text>
                    break
                  case "Sets":
                    return <Text style={styles.titleShortKpi}>Sets</Text>
                    break
                  case "Reps":
                    return <Text style={styles.titleShortKpi}>Reps</Text>
                    break
                  case "Distance":
                    return <Text style={styles.titleShortKpi}>Distance</Text>
                    break
                  case "Work Time (seconds)":
                    return <Text style={styles.titleKpiWT}>Work Time (seconds)</Text>
                    break
                  case "Date":
                    return <Text style={styles.titleKpiWT}>Date</Text>
                    break
                  case "Program Info":
                    return <Text style={styles.titleLongKpi}>Program Info</Text>
                    break
                }
              })}
            </View>
            {gridRowsKpi.map((row, index) => (
              <View key={index + index} style={styles.tableExercises}>
                <View key={index} style={styles.row} wrap={true}>
                  {colsKpi.map((col, index) => {
                    switch (col?.userProvidedColDef?.headerName) {
                      case "Name":
                        return <Text style={styles.cellDataName2}>{row?.name}</Text>
                        break
                      case "Exercise":
                        return <Text style={styles.cellDataName2}>{row?.exercise}</Text>
                        break
                      case "Weight (lbs)":
                        return <Text style={styles.cellDataKpi}>{row?.weight}</Text>
                        break
                      case "Sets":
                        return <Text style={styles.cellDataKpi}>{row?.sets}</Text>
                        break
                      case "Reps":
                        return <Text style={styles.cellDataKpi}>{row?.reps}</Text>
                        break
                      case "Distance":
                        return <Text style={styles.cellDataKpi}>{row?.distance}</Text>
                        break
                      case "Work Time (seconds)":
                        return <Text style={styles.cellDataKpiWT}>{row?.work_time}</Text>
                        break
                      case "Date":
                        return <Text style={styles.cellDataKpiWT}>{row?.date}</Text>
                        break
                      case "Program Info":
                        return <Text style={styles.cellDataKpiProgramInfo}>{row?.program_info}</Text>
                        break
                    }
                  })}
                </View>
              </View>
            ))}
          </Page>
        </Document >
      ).toBlob();
      saveAs(blob, cardData?.orgName);
    }
  }

  return (
    <TeamReportPage.Stylesheet>
      <div style={{display: 'flex', overflow: 'scroll'}}>
        <FormControl variant='outlined' style={{margin: 30, marginLeft: '7.5%', minWidth: '300px', width: '20%'}} >
          <InputLabel >Organization</InputLabel>
            <Select
              value={org}
              onChange={hangleOrgChange}
            >
              {orgList?.map((row) => (
                      <MenuItem value={row} key={row?.id}>{row?.name}</MenuItem>
                  ))}
            </Select>
        </FormControl>

        <FormControl variant='outlined' style={{margin: 30, minWidth: '100px', width: '5%'}} >
          <InputLabel >Days</InputLabel>
            <Select
              value={days}
              onChange={hangleDayChange}
            >
              <MenuItem value={3}>3</MenuItem>
              <MenuItem value={7}>7</MenuItem>
              <MenuItem value={14}>14</MenuItem>
              <MenuItem value={28}>28</MenuItem>
            </Select>
        </FormControl>

        <Chip label='Download PDF' onClick={generatePDF} color='teal' size="Large"
          style={{fontSize: 20,  marginLeft: '25%', marginTop: '2%'}}/>
        <Chip label='Download CSV' onClick={onBtnExport} color='teal' size="Large"
          style={{fontSize: 20,  marginLeft: '5%', marginTop: '2%'}}/>
        <Chip label={members || '-'} color='teal' size="Large"
          style={{fontSize: 20, marginLeft: '5%', marginTop: '2%'}}/>
      </div>
      <div
        className="ag-theme-alpine"
        style={{ height: 550, margin: '0% 7.5%' }}
      >
        <AgGridReact
          rowData={cardData?.memberDataList}
          columnDefs={colDefs}
          defaultColDef={defaultColDef}
          ref={gridRef}
          alwaysMultiSort
          >
        </AgGridReact>
      </div>
      <div style={{marginTop: 50, marginLeft: '7.5%', display: 'flex', overflow: 'scroll'}}>
        <h1> KPI Leaderboard </h1>
        <Chip label='Download CSV' onClick={onBtnExport2} color='teal' size="Large"
          style={{fontSize: 20, marginLeft: '59%'}}/>
      </div>
      <div
        className="ag-theme-alpine"
        style={{ height: 550, margin: '50px 7.5%' }}
      >
        <AgGridReact
          rowData={cardData?.memberKpiList}
          columnDefs={kpiColDefs}
          defaultColDef={defaultColDef}
          ref={gridRefKpi}
          alwaysMultiSort
          >
        </AgGridReact>
      </div>
    </TeamReportPage.Stylesheet>
  )
}

TeamReportPage.Stylesheet = styled.div`

  --ag-header-height: 20px;

  --ag-row-height: 20px;

  --ag-list-item-height: 20px;

  padding-bottom: 100px;

  .card-header {
    border-bottom: none;
    padding: 16px 16px;
  }

  .subtitle {
    font-size: 1rem;
    padding-bottom: 1rem;
  }

  .section{
    padding: 0 4px;
    margin-top: 6px !important;
  }

  .MuiGrid-container {
    height: 200px;
  }

  .card-body{
    padding: 0px 12px;
  }

  .MuiIconButton-root{
    padding 3px;
  }

  .card{
    min-height: 164px;
  }

  h2{
    display: inline;
  }

  .MuiTableCell-root{
    padding: 1px;
    text-align: center;
  }
  .MuiTableCell-head{
    background-color: #0b545e;
    color: white;
    text-align: center;
  }
  .MuiTableRow-root:nth-child(even){
    background-color: #dedede;
  }
  .MUIDataTableHeadCell-toolButton-59{
    color: white;
    text-align: center;
    margin: 0px 0px;
  }
  .MUIDataTableHeadCell-contentWrapper-60{
    justify-content: center;
  }
  .MuiButton-text {
    color: white;
  }
  .jss60 {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ag-theme-alpine {
    --ag-header-background-color: teal;
    --ag-header-font-color: white;
  }
  .ag-theme-alpine .ag-header-cell {
    color: white;
  }
  .ag-body-viewport {
    height: auto !important;
  }

  .ag-theme-alpine .ag-icon .ag-icon-filter {
    color: white;
  }

  .ag-theme-alpine .ag-header-icon {
    color: white;
  }

  .ag-theme-alpine .ag-icon {
    color: white;
  }
`

export default TeamReportPage
